import React from "react";
//import { useState, useEffect } from "react";
import {atom, useSetRecoilState, useRecoilValue} from "recoil";
import * as waxjs from "@waxio/waxjs/dist";
import {useFirebaseUser} from "./firebase-auth";

export const $waxUser = atom({
    key: "WAX::USER", // Atoms needs a unique key, we can only ever call the atom function once with this key.
    default: null,
})

export const $waxKeys = atom({
    key: "WAX::KEYS", // Atoms needs a unique key, we can only ever call the atom function once with this key.
    default: [],
})

export const $waxAuthd = atom({
    key: "WAX::AUTHD", // Atoms needs a unique key, we can only ever call the atom function once with this key.
    default: false,
})

// Our actual hook
export function useWaxUser() {
    const currentWaxUser = useRecoilValue($waxUser)
    const currentKeys = useRecoilValue($waxKeys)
    const authd = useRecoilValue($waxAuthd)

    return {
        account: currentWaxUser,
        pubKeys: currentKeys,
        didAuth: authd
    }
}

export function WaxAuth() {

    const setWaxUser = useSetRecoilState($waxUser)
    const setKeys = useSetRecoilState($waxKeys)
    const setAuth = useSetRecoilState($waxAuthd)

    const firebaseUser = useFirebaseUser();
    const user = useWaxUser();

    const wax = new waxjs.WaxJS('https://wax.greymass.com', null, null, false)
    if (wax.userAccount && Array.isArray(wax.pubKeys)) {
        setWaxUser(wax.userAccount);
        setKeys(wax.pubKeys);
        setAuth(true);
        //let str = 'AutoLogin enabled for account: ' + userAccount + '<br/>Active: ' + pubKeys[0] + '<br/>Owner: ' + pubKeys[1]
    }

    //checks if autologin is available 
    async function _login_helper(confirmationWindow) {
        let userAccount = await wax.loginViaWindow(confirmationWindow);
        let pubKeys = wax.pubKeys;
        setWaxUser(userAccount);
        setKeys(pubKeys);
        setAuth(true);
    }

    function login() {
        const confirmationWindow = window.open(wax.waxSigningURL + "/cloud-wallet/login/", "WaxPopup", "height=800,width=600");
        _login_helper(confirmationWindow);
    }

    return (!user.didAuth && !firebaseUser.hasWallet) ? (
        <button className="banner-button nav navbar-nav navbar-right">
            <a id="login-register" className="popuplink" href="#" onClick={() => {
                login();
            }}>Add Wallet</a>
        </button>
    ) : (
        <div></div>
    );

}